<script lang="ts">

	import { onDestroy, SvelteComponent } from 'svelte';
	import { storeCurRoute, routes } from './router';

	let component: typeof SvelteComponent;
	let props = {};
	let anchor: string = "";

	const unsubscribe = storeCurRoute.subscribe(routeId => {
		const route = routes.filter((r) => r.id === routeId)[0];
		component = route.component;
		if (route.anchor != "") {
			anchor = route.anchor;
		} else {
			anchor = "";
		}
	});

	onDestroy(unsubscribe);
  
</script>

<style lang="scss">
  .route {
    grid-area: route;
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
  }
</style>

<div class="route">
  {#if anchor !== ""}
    {#key anchor}
      <svelte:component this={component} {anchor}/>
    {/key}
  {:else}
    <svelte:component this={component}/>
  {/if}
</div>